import {
  Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild,
} from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { ToastrService } from 'ngx-toastr';
import { Subscription, Observable } from 'rxjs';
import {
  ILLCustomerCompaniesByTypeWrapper, ILLEstablishment, ILLFormDetail, ILLRelationship, ICompanyDetail, ILLCompany,
} from '../../../../shared/models/index';
import { LLFormService, CompanyContactService } from '../../../../shared/services/index';

@Component({
    selector: 'app-establishment-modal',
    templateUrl: './establishment-modal.component.html',
    styleUrls: ['./establishment-modal.component.scss'],
    standalone: false
})
export class EstablishmentModalComponent implements OnInit, OnDestroy, OnChanges {
  modalValWidth = '500px';
  modalValHeight = 'auto';
  public modalValVisible = true;
  public modalValHidden = false;

  target = '#modalTarget';
  ddwFields: Object = { text: 'companyName', value: 'companyRevisionId' };
  position: object = { X: 'center', Y: 'center' };
  modalWidth = '60%';
  modalHeight = '80%';
  animationSettings: Object = { effect: 'Zoom' };
  isModal = true;
  visible = false;
  companyRevisionId: any;
  ddwHeight = '220px';
  companyDataSource: any[] = [];
  estabForm: UntypedFormGroup;
  allEstablishmentCompanies: ILLEstablishment[] = [];
  revisionEstabCompanies: ILLEstablishment[] = [];
  companyCnt: number;
  llFormDetails: ILLFormDetail;
  availableEstabCompaniesCount: number;
  revisionLabelerNdcCode: any;
  productInfoForm: any;
  labelerForm: any;
  establishmentsExist = true;
  ddwCompanySelected = false;
  warningModalText = '';
  iconTypeCompany = true;
  company$: Observable<ICompanyDetail> | null;
  productLabeler: string;
  originalEstabForm: UntypedFormGroup;
  originalFormData: any;
  pageLoaded = false;

  sub: Subscription;

  @ViewChild('modalDialog')
  public modalDialog: DialogComponent;

  @ViewChild('dialog')
  public dialog: DialogComponent;

  @Input() llFormData: ILLFormDetail;
  @Output() modalEstabData = new EventEmitter<any>();
  @Input() changedNdcCode: any;
  @Input() bDeleteProduct: boolean;

  BtnClick: EmitType<object> = () => {
    this.dialog.show();
  };

  ndcProductLinkNotAllowed: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    private toastr: ToastrService,
    private llFormService: LLFormService,
    private companyService: CompanyContactService,
    private llService: LLFormService,
  ) { }

  dlgButtonClick: EmitType<object> = () => {
    this.modalDialog.hide();
  };

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public buttons: Object[] = [{ click: this.dlgButtonClick.bind(this), buttonModel: { content: 'OK', isPrimary: true } }];

  ngOnInit() {
    this.llService.llFormEstablishmentSubject.next(null);
    this.initializeModal();

    this.formProductLabeler();

    this.estabForm.markAsPristine();
  }

  initializeModal() {
    this.sub = this.llFormService.llFormLabelerSubject.subscribe(lb => {
      this.labelerForm = lb;
    });

    this.sub = this.llFormService.llFormProductInformationSubject.subscribe(pi => {
      this.productInfoForm = pi;
    });

    this.estabForm = this.fb.group({
      companies: this.fb.array([this.company]),
    });

    if (this.llFormData && this.llFormData[0].data) {
      this.llFormDetails = this.llFormData[0].data;

      this.revisionEstabCompanies = this.llFormDetails.establishments || [];
    }

    this.setCompaniesDdw();

    // Watches changes on the entire form
    this.estabForm.valueChanges.subscribe(data => {

    });

    if (this.llFormDetails) {
      if (this.revisionEstabCompanies && this.revisionEstabCompanies.length > 0) {
        this.estabForm.setControl('companies', this.setOrigCompanies(this.revisionEstabCompanies));
      } else {
        this.establishmentsExist = false;
      }

      // For certain FDA Centers, disable or re-enable some options
      this.ndcProductLinkNotAllowed = this.llFormDetails.fdaCenter.ndcProductLinkNotAllowed;
    }
  }

  setBOs() {
    if (this.companies && this.companies.length > 0) {
      this.companies.controls.forEach((company, c) => {
        if (company.value.companyRevisionId) {
          this.setOrigBOs(company.value.companyRevisionId, c);
        }
      });
    }
  }

  boChkChanged(event, compIndex, boIndex) {
    const checked: boolean = event.checked;

    if (!checked && !this.ndcProductLinkNotAllowed) {
      const products = ((<UntypedFormArray> this.estabForm.controls.companies).at(compIndex).get('busOps') as UntypedFormArray).at(boIndex).get('products') as UntypedFormArray;

      if (products && products.controls.length > 0) {
        products.controls.forEach(product => {
          product.patchValue({ selected: checked });
        });
      }
    }
  }

  productChkChanged(event, ci, bi, pi) {
    const checked: boolean = event.checked;

    const company = (<UntypedFormArray> this.estabForm.controls.companies).at(ci) as UntypedFormArray;
    const bo = ((<UntypedFormArray> this.estabForm.controls.companies).at(ci).get('busOps') as UntypedFormArray).at(bi) as UntypedFormArray;
    const products = ((<UntypedFormArray> this.estabForm.controls.companies).at(ci).get('busOps') as UntypedFormArray).at(bi).get('products') as UntypedFormArray;

    if (products && products.controls.length > 0) {
      products.controls[pi].patchValue({ selected: checked });

      const selectedProducts = products.value.filter(s => s.selected);

      if (selectedProducts && selectedProducts.length) {
        ((<UntypedFormArray> this.estabForm.controls.companies).at(ci).get('busOps') as UntypedFormArray).at(bi).patchValue({ selected: true });
      }

      if (this.llFormData && this.llFormData[0].data) {
        if (this.llFormData[0].data.establishments[ci]) {
          if (this.llFormData[0].data.establishments[ci].businessOperations[bi]) {
            this.llFormData[0].data.establishments[ci].businessOperations[bi] = bo;
          }
        }
      }
    }
  }

  boDisplayed(compIndex, boIndex) {
    const bo = ((<UntypedFormArray> this.estabForm.controls.companies).at(compIndex).get('busOps') as UntypedFormArray).at(boIndex);

    return !!(bo.value.busOpCode);
  }

  setOrigCompanies(estabCompanies: ILLEstablishment[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    let estabCompany: any;

    estabCompanies.forEach((company, i) => {
      estabCompany = this.fb.group({
        companyRevisionId: company.establishmentCompany.companyRevisionId,
        companyName: company.establishmentCompany.companyName,
        confidential: company.confidentiality,
        busOps: this.setOrigBOs(company.establishmentCompany.companyRevisionId, i),
      });
      formArray.push(estabCompany);
    });

    this.companyCnt = formArray.length;
    return formArray;
  }

  get company(): UntypedFormGroup {
    return this.fb.group({
      companyRevisionId: ['', { updateOn: 'blur' }],
      companyName: '',
      confidential: ['N', { updateOn: 'blur' }],
      busOps: this.fb.array([this.busOp]),
    });
  }

  companySelectionChanged(event, i) {
    if (event.isInteracted) {
      if (event.value) {
        this.setOrigBOs(event.value, i);

        this.ddwCompanySelected = true;
      }
    }
  }

  setOrigBOs(companyRevisionId, index) {
    let company: UntypedFormGroup;

    const BOs: UntypedFormArray = <UntypedFormArray> this.setBOForm(companyRevisionId);

    const estab = this.getAvailableEstablishment(companyRevisionId);

    const revisionEstab = this.getRevisionEstablishment(companyRevisionId, estab);

    let revisionEstabConfidentiality = false;

    if (revisionEstab) {
      switch (revisionEstab.confidentiality.toString()) {
        case 'N':
          revisionEstabConfidentiality = false;
          break;
        case 'Y':
          revisionEstabConfidentiality = true;
          break;
        case 'true':
          revisionEstabConfidentiality = true;
          break;
        case 'false':
          revisionEstabConfidentiality = false;
          break;
      }
    } else {
      revisionEstabConfidentiality = false;
    }

    company = this.fb.group({
      companyRevisionId: companyRevisionId,
      companyName: revisionEstab ? revisionEstab.establishmentCompany.companyName : (estab ? estab.establishmentCompany.companyName : ''),
      dunsNumber: revisionEstab ? revisionEstab.establishmentCompany.dunsNumber : (estab ? estab.establishmentCompany.dunsNumber : ''),
      confidential: revisionEstabConfidentiality,
      busOps: BOs,
    });

    this.companies.setControl(index, company);
  }

  get busOp(): UntypedFormGroup {
    return this.fb.group({
      busOpId: [''],
      busOpCode: [''],
      busOpLabel: [''],
      businessOperationsCompanyRevisionId: [''],
      selected: [true],
      products: this.fb.array([this.product]),
    });
  }

  get product(): UntypedFormGroup {
    return this.fb.group({
      ndcProductCode: [''],
      selected: [true],
    });
  }

  setBOForm(companyRevisionId: number): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    let establishment: ILLEstablishment;

    this.availableEstabCompaniesCount = this.allEstablishmentCompanies ? this.allEstablishmentCompanies.length : 0;

    // check selected busOps and products.
    establishment = this.getAvailableEstablishment(companyRevisionId);
    const uploadedEstablishments = this.getRevisionEstablishments(companyRevisionId, establishment);

    if (establishment || uploadedEstablishments.length > 0) {
      const displayBusinessOperations = this.getDisplayBusinessOperations(establishment, uploadedEstablishments);

      if (displayBusinessOperations && displayBusinessOperations.length > 0) {
        displayBusinessOperations.forEach((b: ILLRelationship) => {
          let productsFormArray = new UntypedFormArray([]);
          const businessOperationId = this.getRelationshipBusinessOperationId(b);

          productsFormArray = this.setProducts(b, companyRevisionId, displayBusinessOperations);
          if (!productsFormArray || productsFormArray.length === 0) {
            return;
          }

          // find if bus op exist in revision estabs
          const busOp = this.getRevisionBusinessOperation(companyRevisionId, b, establishment);

          const boObject: UntypedFormGroup = this.fb.group({
            busOpId: businessOperationId,
            busOpCode: this.getBusinessOperationCode(b.businessOperations),
            busOpLabel: this.getBusinessOperationLabel(b.businessOperations),
            businessOperationsCompanyRevisionId: businessOperationId,
            selected: uploadedEstablishments.length > 0 ? this.isBusinessOperationSelected(busOp) : true,
            products: [this.fb.array([this.product])],
          });

          boObject.setControl('products', productsFormArray);

          formArray.push(boObject);
        });
      }
    }

    return formArray;
  }

  formProductLabeler() {
    this.sub = this.llFormService.llFormProductLabelerCodeSubject.subscribe(data => {
      const productProductCode = data;
      const productLabelerCode = productProductCode ? productProductCode.split('-')[0] : '';

      this.productLabeler = productLabelerCode;
    });
  }

  businessOperationIdsMatch(firstId: any, secondId: any): boolean {
    return firstId !== undefined && firstId !== null
      && secondId !== undefined && secondId !== null
      && firstId.toString() === secondId.toString();
  }

  normalizeBusinessOperationCode(value: any): string {
    const normalizedCode = value ? value.toString().trim().toUpperCase() : '';
    const codeMatch = normalizedCode.match(/C\d+/);

    return codeMatch ? codeMatch[0] : normalizedCode;
  }

  getBusinessOperationCode(businessOperation: any): string {
    const code = businessOperation ? this.normalizeBusinessOperationCode(businessOperation.code) : '';

    if (code) {
      return code;
    }

    return businessOperation ? this.normalizeBusinessOperationCode(businessOperation.label) : '';
  }

  getBusinessOperationLabel(businessOperation: any): string {
    const label = businessOperation && businessOperation.label ? businessOperation.label.toString().trim() : '';

    if (label) {
      return label
        .replace(/\s*\(\s*C\d+\s*\)\s*$/i, '')
        .replace(/\s+C\d+\s*$/i, '')
        .trim();
    }

    return businessOperation && businessOperation.name ? businessOperation.name.toString().trim() : '';
  }

  businessOperationsMatch(firstBusinessOperation: any, secondBusinessOperation: any): boolean {
    const firstId = firstBusinessOperation ? firstBusinessOperation.id : null;
    const secondId = secondBusinessOperation ? secondBusinessOperation.id : null;
    const firstCode = this.getBusinessOperationCode(firstBusinessOperation);
    const secondCode = this.getBusinessOperationCode(secondBusinessOperation);

    if (this.businessOperationIdsMatch(firstId, secondId)) {
      return true;
    }

    return !!(firstCode && secondCode && firstCode === secondCode);
  }

  businessOperationHasValue(businessOperation: any): boolean {
    return !!(businessOperation && (
      businessOperation.id
      || this.getBusinessOperationCode(businessOperation)
      || this.getBusinessOperationLabel(businessOperation)
    ));
  }

  getRelationshipBusinessOperationId(relationship: ILLRelationship): any {
    if (!relationship) {
      return null;
    }

    const businessOperation = relationship.businessOperations;

    if (businessOperation && businessOperation.id) {
      return businessOperation.id;
    }

    return relationship.businessOperationsCompanyRevisionId;
  }

  relationshipHasValue(relationship: ILLRelationship): boolean {
    return !!(relationship && (
      this.getRelationshipBusinessOperationId(relationship)
      || this.businessOperationHasValue(relationship.businessOperations)
    ));
  }

  businessOperationRelationshipsMatch(firstRelationship: ILLRelationship, secondRelationship: ILLRelationship): boolean {
    const firstId = this.getRelationshipBusinessOperationId(firstRelationship);
    const secondId = this.getRelationshipBusinessOperationId(secondRelationship);

    if (this.businessOperationIdsMatch(firstId, secondId)) {
      return true;
    }

    return this.businessOperationsMatch(
      firstRelationship ? firstRelationship.businessOperations : null,
      secondRelationship ? secondRelationship.businessOperations : null
    );
  }

  isBusinessOperationSelected(relationship: ILLRelationship): boolean {
    if (!relationship) {
      return false;
    }

    const selected: any = relationship.selected;

    return selected === true
      || selected === 'true'
      || (selected === undefined && this.getUniqueNdcProductCodes(relationship.ndcProductCode).length > 0);
  }

  getDisplayBusinessOperations(selectedEstablishment: ILLEstablishment, uploadedEstablishments: ILLEstablishment[]): ILLRelationship[] {
    const displayBusinessOperations: ILLRelationship[] = [];
    let businessOperations = [];

    businessOperations = businessOperations.concat(selectedEstablishment && selectedEstablishment.businessOperations
      ? selectedEstablishment.businessOperations
      : []);

    if (uploadedEstablishments && uploadedEstablishments.length > 0) {
      uploadedEstablishments.forEach(uploadedEstablishment => {
        businessOperations = businessOperations.concat(uploadedEstablishment && uploadedEstablishment.businessOperations
          ? uploadedEstablishment.businessOperations
          : []);
      });
    }

    businessOperations.forEach((businessOperation: ILLRelationship) => {
      if (!this.relationshipHasValue(businessOperation)) {
        return;
      }

      const existingBusinessOperation = displayBusinessOperations
        .find(displayBusinessOperation => this.businessOperationRelationshipsMatch(displayBusinessOperation, businessOperation));

      if (!existingBusinessOperation) {
        displayBusinessOperations.push(businessOperation);
      }
    });

    return displayBusinessOperations;
  }

  companyRevisionIdsMatch(firstId: any, secondId: any): boolean {
    return firstId !== undefined && firstId !== null
      && secondId !== undefined && secondId !== null
      && firstId.toString() === secondId.toString();
  }

  getAvailableEstablishment(estabCompanyId: number): ILLEstablishment {
    return this.allEstablishmentCompanies.find(c => this.companyRevisionIdsMatch(c.establishmentCompany.companyRevisionId, estabCompanyId));
  }

  normalizeDunsNumber(value: any): string {
    return value ? value.toString().replace(/\D/g, '') : '';
  }

  normalizeCompanyName(value: any): string {
    return value
      ? value.toString().replace(/^\(\s*\d+\s*\)\s*/, '').trim().replace(/\s+/g, ' ').toLowerCase()
      : '';
  }

  getCompanyDunsNumber(company: ILLCompany): string {
    if (!company) {
      return '';
    }

    const dunsNumber = this.normalizeDunsNumber(company.dunsNumber);

    if (dunsNumber) {
      return dunsNumber;
    }

    const companyNameMatch = company.companyName ? company.companyName.toString().match(/^\(\s*(\d+)\s*\)/) : null;

    return companyNameMatch ? this.normalizeDunsNumber(companyNameMatch[1]) : '';
  }

  getUniqueEstablishments(establishments: ILLEstablishment[]): ILLEstablishment[] {
    const uniqueEstablishments: ILLEstablishment[] = [];

    (establishments || []).forEach(establishment => {
      if (establishment && uniqueEstablishments.indexOf(establishment) === -1) {
        uniqueEstablishments.push(establishment);
      }
    });

    return uniqueEstablishments;
  }

  getCurrentFormEstablishments(): ILLEstablishment[] {
    return this.getUniqueEstablishments(
      (this.revisionEstabCompanies || [])
        .concat(this.llFormDetails && this.llFormDetails.establishments ? this.llFormDetails.establishments : [])
    );
  }

  getRevisionEstablishments(estabCompanyId: number, selectedEstablishment?: ILLEstablishment): ILLEstablishment[] {
    const revisionEstablishments = this.getCurrentFormEstablishments();
    const selectedCompany = selectedEstablishment ? selectedEstablishment.establishmentCompany : null;
    const selectedDunsNumber = this.getCompanyDunsNumber(selectedCompany);
    const selectedCompanyName = this.normalizeCompanyName(selectedCompany ? selectedCompany.companyName : '');
    const matchingCompanyRevisions = revisionEstablishments
      .filter(c => this.companyRevisionIdsMatch(c.establishmentCompany.companyRevisionId, estabCompanyId));

    if (matchingCompanyRevisions.length > 0) {
      return this.getUniqueEstablishments(matchingCompanyRevisions);
    }

    if (selectedDunsNumber) {
      const matchingDunsNumbers = revisionEstablishments
        .filter(c => this.getCompanyDunsNumber(c.establishmentCompany) === selectedDunsNumber);

      if (matchingDunsNumbers.length > 0) {
        return this.getUniqueEstablishments(matchingDunsNumbers);
      }
    }

    if (selectedCompanyName) {
      return this.getUniqueEstablishments(revisionEstablishments
        .filter(c => this.normalizeCompanyName(c.establishmentCompany.companyName) === selectedCompanyName));
    }

    return [];
  }

  getRevisionEstablishment(estabCompanyId: number, selectedEstablishment?: ILLEstablishment): ILLEstablishment {
    const revisionEstablishments = this.getRevisionEstablishments(estabCompanyId, selectedEstablishment);

    return revisionEstablishments.length > 0 ? revisionEstablishments[0] : null;
  }

  getNdcProductCodeValue(productCode: any): string {
    if (!productCode) {
      return '';
    }

    return productCode.ndcProductCode ? productCode.ndcProductCode.toString() : productCode.toString();
  }

  isValidNdcProductCode(productCode: string): boolean {
    const codeParts = productCode ? productCode.split('-') : [];

    return !!(codeParts[0]
      && codeParts[1]
      && codeParts[0].toLowerCase() !== 'xxxx'
      && codeParts[0].toLowerCase() !== 'null'
      && codeParts[1].toLowerCase() !== 'null');
  }

  getUniqueNdcProductCodes(productCodes: any): string[] {
    const uniqueProductCodes: string[] = [];
    const productCodeArray = Array.isArray(productCodes) ? productCodes : [productCodes];

    productCodeArray.forEach(productCode => {
      const ndcProductCodes = this.getNdcProductCodeValue(productCode)
        .split(',')
        .map(ndcProductCode => ndcProductCode.trim());

      ndcProductCodes.forEach(ndcProductCode => {
        if (this.isValidNdcProductCode(ndcProductCode) && uniqueProductCodes.indexOf(ndcProductCode) === -1) {
          uniqueProductCodes.push(ndcProductCode);
        }
      });
    });

    return uniqueProductCodes;
  }

  getUploadedEstablishmentNdcProductCodes(estabCompanyId: number, selectedEstablishment?: ILLEstablishment, displayBusinessOperations?: ILLRelationship[]): string[] {
    const ndcProductCodes: string[] = [];
    const uploadedEstablishments = this.getRevisionEstablishments(estabCompanyId, selectedEstablishment);

    if (uploadedEstablishments && uploadedEstablishments.length > 0) {
      uploadedEstablishments.forEach(uploadedEstablishment => {
        if (uploadedEstablishment && uploadedEstablishment.businessOperations && uploadedEstablishment.businessOperations.length > 0) {
          uploadedEstablishment.businessOperations.forEach(b => {
            this.getUniqueNdcProductCodes(b.ndcProductCode).forEach(productCode => ndcProductCodes.push(productCode));
          });
        }
      });
    }

    if (selectedEstablishment && selectedEstablishment.businessOperations && selectedEstablishment.businessOperations.length > 0) {
      selectedEstablishment.businessOperations.forEach(b => {
        this.getUniqueNdcProductCodes(b.ndcProductCode).forEach(productCode => ndcProductCodes.push(productCode));
      });
    }

    if (displayBusinessOperations && displayBusinessOperations.length > 0) {
      displayBusinessOperations.forEach(b => {
        this.getUniqueNdcProductCodes(b.ndcProductCode).forEach(productCode => ndcProductCodes.push(productCode));
      });
    }

    return this.getUniqueNdcProductCodes(ndcProductCodes).sort();
  }

  getFormProductNdcProductCodes(): string[] {
    const ndcProductCodes: string[] = [];
    const products = this.llFormDetails && this.llFormDetails.products ? this.llFormDetails.products : [];

    products.forEach(product => {
      this.getUniqueNdcProductCodes(product.ndcProductCode).forEach(productCode => ndcProductCodes.push(productCode));

      if (product['parts'] && product['parts'].length > 0) {
        product['parts'].forEach(part => {
          this.getUniqueNdcProductCodes(part.ndcProductCode).forEach(productCode => ndcProductCodes.push(productCode));
        });
      }
    });

    return this.getUniqueNdcProductCodes(ndcProductCodes).sort();
  }

  getRevisionBusinessOperation(estabCompanyId: number, businessOperation: ILLRelationship, selectedEstablishment?: ILLEstablishment): ILLRelationship {
    const establishments = this.getRevisionEstablishments(estabCompanyId, selectedEstablishment);
    let matchingBusinessOperation: ILLRelationship = null;

    establishments.forEach(estab => {
      if (!matchingBusinessOperation && estab && estab.businessOperations && estab.businessOperations.length > 0) {
        matchingBusinessOperation = estab.businessOperations.find(bop => this.businessOperationRelationshipsMatch(bop, businessOperation));
      }
    });

    return matchingBusinessOperation;
  }

  getSelectedNdcProductCodes(estabCompanyId: number, businessOperation: ILLRelationship, selectedEstablishment?: ILLEstablishment): string[] {
    const selectedNdcProductCodes: string[] = [];
    const establishments = this.getRevisionEstablishments(estabCompanyId, selectedEstablishment);

    establishments.forEach(estab => {
      if (estab && estab.businessOperations && estab.businessOperations.length > 0) {
        estab.businessOperations
          .filter(bop => this.isBusinessOperationSelected(bop) && this.businessOperationRelationshipsMatch(bop, businessOperation))
          .forEach(bop => {
            this.getUniqueNdcProductCodes(bop.ndcProductCode).forEach(productCode => selectedNdcProductCodes.push(productCode));
          });
      }
    });

    return this.getUniqueNdcProductCodes(selectedNdcProductCodes);
  }

  setProducts(bo: ILLRelationship, estabCompanyId: number, displayBusinessOperations?: ILLRelationship[]): UntypedFormArray {
    const productsFormArray = new UntypedFormArray([]);

    if (this.llFormData && this.llFormData[0].data) {
      const selectedEstablishment = this.getAvailableEstablishment(estabCompanyId);
      const revisionEstablishment = this.getRevisionEstablishment(estabCompanyId, selectedEstablishment);
      const revisionBusinessOperation = this.getRevisionBusinessOperation(estabCompanyId, bo, selectedEstablishment);
      const selectedNdcProductCodes = this.getSelectedNdcProductCodes(estabCompanyId, bo, selectedEstablishment);
      const establishmentNdcProductCodes = this.getUploadedEstablishmentNdcProductCodes(estabCompanyId, selectedEstablishment, displayBusinessOperations);
      const fallbackNdcProductCodes = establishmentNdcProductCodes.length > 0 ? [] : this.getFormProductNdcProductCodes();
      const displayNdcProductCodes = this.getUniqueNdcProductCodes(
        establishmentNdcProductCodes.concat(selectedNdcProductCodes).concat(fallbackNdcProductCodes)
      ).sort();

      if (displayNdcProductCodes && displayNdcProductCodes.length > 0) {
        const busOpSelected = revisionEstablishment ? this.isBusinessOperationSelected(revisionBusinessOperation) : true;

        displayNdcProductCodes.forEach(element => {
          const product: UntypedFormGroup = this.fb.group({
            ndcProductCode: `${element}`,
            selected: !!(((revisionEstablishment ? selectedNdcProductCodes.indexOf(element) >= 0 : true) && busOpSelected && !this.ndcProductLinkNotAllowed)),
          });

          productsFormArray.push(product);
        });
      }
    }

    return productsFormArray;
  }

  compare(a, b) {
    if (a.establishmentCompany.companyName < b.establishmentCompany.companyName) {
      return -1;
    }
    if (a.establishmentCompany.companyName > b.establishmentCompany.companyName) {
      return 1;
    }
    return 0;
  }

  setCompaniesDdw() {
    this.companyDataSource = [];

    if (this.llFormData && this.llFormData[2].data) {
      const companyTypes: ILLCustomerCompaniesByTypeWrapper = this.llFormData[2].data;

      // unique companies
      // this.allEstablishmentCompanies = Array.from(new Set(companyTypes.establishments.concat(companyTypes.establishmentsThirdParty))).sort(this.compare);

      this.allEstablishmentCompanies = this.getAllEstablishmentCompanies(companyTypes);

      this.availableEstabCompaniesCount = this.allEstablishmentCompanies.length;
    }

    if (this.allEstablishmentCompanies && this.allEstablishmentCompanies.length > 0) {
      this.allEstablishmentCompanies.forEach((est: ILLEstablishment) => {
        this.addCompanyDataSource(est);
      });
    }

    this.getCurrentFormEstablishments().forEach((est: ILLEstablishment) => {
      this.addCompanyDataSource(est);
    });
  }

  getAllEstablishmentCompanies(companyTypes: ILLCustomerCompaniesByTypeWrapper): ILLEstablishment[] {
    return Array.from(new Set(
      (companyTypes.establishments || [])
        .concat(companyTypes.establishmentsThirdParty || [])
        .concat(companyTypes.establishmentOwnedAndEstablishmentThirdParty || [])
    ));
  }

  addCompanyDataSource(est: ILLEstablishment): void {
    if (!est || !est.establishmentCompany || !est.establishmentCompany.companyRevisionId) {
      return;
    }

    const companyRevisionId = est.establishmentCompany.companyRevisionId;
    const existingCompany = this.companyDataSource
      .find(ds => this.companyRevisionIdsMatch(ds.companyRevisionId, companyRevisionId));

    if (existingCompany) {
      return;
    }

    this.companyDataSource.push({
      companyRevisionId: +companyRevisionId,
      companyName: est.establishmentCompany.companyName,
    });
  }

  get companies(): UntypedFormArray {
    return this.estabForm.get('companies') as UntypedFormArray;
  }

  get companyFormControls() {
    return this.companies.controls;
  }

  busOpsArray(boIndex: number): UntypedFormArray {
    const arr = this.companies.at(boIndex).get('busOps') as UntypedFormArray;

    return arr;
  }

  busOpsArrayChkVisible(compIndex: number, boIndex: number): boolean {
    const arr = this.companies.at(compIndex).get('busOps') as UntypedFormArray;

    return !!(arr && arr.controls && arr.controls[boIndex]
      && (arr.controls[boIndex].value.busOpCode || arr.controls[boIndex].value.busOpLabel || arr.controls[boIndex].value.busOpId));
  }

  productsArray(compIndex: number, boIndex: number): UntypedFormArray {
    const arr = ((<UntypedFormArray> this.estabForm.controls.companies).at(compIndex).get('busOps') as UntypedFormArray).at(boIndex).get('products') as UntypedFormArray;

    return arr;
  }

  productsArrayChkVisible(compIndex: number, boIndex: number): boolean {
    const arr = ((<UntypedFormArray> this.estabForm.controls.companies).at(compIndex).get('busOps') as UntypedFormArray).at(boIndex).get('products') as UntypedFormArray;

    const val = arr && arr.controls && arr.controls[0] && arr.controls[0].value.ndcProductCode;

    return val;
  }

  addCompany(): void {
    this.companies.push(this.company);
    this.companyCnt++;
  }

  removeCompany(event, i) {
    this.companies.removeAt(i);
    this.companyCnt--;
  }

  isDuplicateCompanies(): boolean {
    let isDuplicate: boolean;

    const valueArr = this.companies.controls.map(function (item) {
      return item.value.companyRevisionId ? item.value.companyRevisionId.toString() : '';
    });

    isDuplicate = valueArr.some(function (item, idx) {
      return valueArr.indexOf(item) !== idx;
    });

    return isDuplicate;
  }

  saveEstab(form: UntypedFormGroup, cancel?: boolean) {
    let errorMessage;

    if (this.isDuplicateCompanies()) {
      errorMessage = 'Establishments are not unique. Please remove duplicates.';
    }

    if (!this.areCompaniesLatest() && !cancel) {
      errorMessage = 'One of the establishment companies is missing or not the latest revision.';
    }

    if (!errorMessage) {
      this.modalEstabData.emit({ estabForm: form.value, originalFormData: this.originalFormData, cancel: cancel });

      this.establishmentsExist = form.value.companies.length > 0;

      this.visible = false;

      this.dialog.hide();
    } else {
      this.toastr.error(errorMessage);
      this.pageLoaded = true;
    }
  }

  // Check if the previously saved company is the latest version
  areCompaniesLatest() {
    const notLatestCompanies = [];

    const valueArr = this.companies.controls.map(function (item) {
      return item.value.companyRevisionId;
    });

    if (valueArr && valueArr.length) {
      valueArr.forEach(element => {
        const company = this.getAvailableEstablishment(element);

        if (!company) {
          notLatestCompanies.push(element);
        }
      });
    }

    return notLatestCompanies.length === 0;
  }

  // Check if the previously saved company is the latest version
  isCompanyLatest(companyRevisionId: number) {
    if (companyRevisionId) {
      const company = this.getAvailableEstablishment(companyRevisionId);

      if (!company) {
        return false;
      }
    }

    return true;
  }

  dlgBtnClick: EmitType<object> = () => {
    this.dialog.hide();
  };

  estabModalCancel(event) {
    this.visible = false;
    this.dialog.hide();

    this.saveEstab(this.originalEstabForm, true);
  }

  onDialogCreated(event) {
    this.estabForm.reset();
    this.companies.reset();
    this.busOp.reset();
    this.product.reset();
  }

  onDialogDestroyed(event) {
    this.estabForm.reset();
    this.companies.reset();
    this.busOp.reset();
    this.product.reset();
  }

  onOverlayClick: EmitType<object> = () => {
    this.modalDialog.hide();
  };

  onDialogOpen(event) {
    this.pageLoaded = false;

    this.initializeModal();

    if (this.companies && this.companies.length > 0) {
      this.companies.controls.forEach((company, c) => {
        if (company.value.companyRevisionId) {
          this.setOrigBOs(company.value.companyRevisionId, c);
        }
      });

      // store the original state of the form for the canceling event.
      this.originalEstabForm = this.llService.cloneAbstractControl(this.estabForm);
      this.originalFormData = this.llService.deepCopy(this.llFormData[0].data);
    }

    this.pageLoaded = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    // eslint-disable-next-line guard-for-in
    for (const property in changes) {
      switch (property) {
        case 'changedNdcCode':
          // We only update the data when the current ndcProductCode is not empty
          if (changes[property].currentValue && changes[property].currentValue.split('|')[1]) {
            this.updateEstablishments();
          }
          break;

        case 'bDeleteProduct':
          this.updateEstablishments();
          break;

        default:
          break;
      }
    }
  }

  // Update establishment information for LL form
  updateEstablishments() {
    this.initializeModal();
    this.formProductLabeler();
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
